import { render } from "./IconLocation.vue?vue&type=template&id=50ea9d45"
import script from "./IconLocation.vue?vue&type=script&lang=js"
export * from "./IconLocation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\suph-annuaire-plugin\\suph-card-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__